import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import "./ResultsTable.css";

const ResultsTable = ({ result }) => {
  const [data, setData] = useState([]);
  const [title, setTitle] = useState("Loading...");

  useEffect(() => {
    if (!result) return;

    const filePath = `/${result}.xlsx`; // Dynamically set file path

    fetch(filePath)
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        const workbook = XLSX.read(buffer, { type: "array" });
        const sheetName = workbook.SheetNames[0]; // Get the sheet name (title)
        setTitle(result); // Set the table title dynamically

        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet); // Convert to JSON
        setData(jsonData);
      })
      .catch((error) => console.error("Error loading Excel file:", error));
  }, [result]); // Runs when targetDate changes

  return (
    <div className="table-container">
      <h2 className="table-title">{title}</h2>
      {data.length > 0 ? (
        <div className="table-wrapper">
          <table className="adventure-table">
            <thead>
              <tr>
                {Object.keys(data[0]).map((key, index) => (
                  <th key={index}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {Object.values(row).map((cell, cellIndex) => (
                    <td key={cellIndex}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Loading data...</p>
      )}
    </div>
  );
};

export default ResultsTable;
